var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('public-tem',{attrs:{"mainTabs":false,"mainBody":false}},[_c('div',{attrs:{"slot":"topShow"},slot:"topShow"},[_c('img',{attrs:{"src":require("imgs/case/guanli.jpg"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }